<div class="image-container">
  <div *ngFor="let imageUrl of imageUrls" class="image-wrapper">
    <ng-container *ngIf="data?.is_audit == 2 && !data?.isView">
      <input type="checkbox" [(ngModel)]="imageUrl.selected" (change)="onCheckboxChange(imageUrl.id, 'image')">
    </ng-container>
    <img [src]="imageUrl.url" alt="Image" class="fixed-size" />
    <p>{{ imageUrl.name }}</p>
  </div>
  <div *ngFor="let documentUrl of documentUrls" class="document-wrapper">
    <ng-container *ngIf="data?.is_audit == 2 && !data?.isView">
      <input type="checkbox" [(ngModel)]="documentUrl.selected" (change)="onCheckboxChange(documentUrl.id, 'document')">
    </ng-container>
      <img src="\assets\img\doc.png" alt="Document"  class="fixed-size"/>
    <p>{{ documentUrl.name }}</p>
    <a [href]="documentUrl.url" download="{{ 'document.' + documentUrl.extension }}">Download</a>
  </div>
</div>
<div *ngIf="imageUrls.length === 0 && documentUrls.length === 0" class="loader-container">
  <mat-spinner *ngIf="showLoader" [fullScreen]="false" diameter="50" strokeWidth="5"></mat-spinner>
  <p *ngIf="!showLoader">No images or documents available.</p>
</div>
<br />
<div class="button-container">
  <button mat-button class="add-button" (click)="fileInput.click()" *ngIf="data?.is_audit == 2 && !data?.isView">Add
    Image</button>
  <input type="file" hidden #fileInput (change)="onFileSelected($event)" accept="image/*" multiple />
  <button mat-button class="delete-button" *ngIf="hasSelectedItems() && !data?.isView" (click)="deleteSelected()">Remove
    Selected</button>
  <button mat-button class="cancel-button" (click)="cancel()">Cancel</button>
  <button mat-button class="add-button" *ngIf="data?.is_audit == 2 && !data?.isView" (click)="saveFile()">Save</button>
</div>






